import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionBlockChain = () => {
  const { t } = useTranslation();
  const tags = [
    '#Binance Smart Chain',
    '#Ethereum',
    '#Polkadot',
    '#NEO',
    '#Stella',
    '#TRON',
    '#Solana',
    '#Polygon',
    '#Aurora',
    '#Cardano',
    '#SUI',
  ];
  const technology = [
    {
      label1: t('Blockchain Protocols'),
      label2: t('Ethereum, Binance Smart Chain, Polkadot'),
    },
    {
      label1: t('Smart Contracts'),
      label2: t('Solidity, Vyper'),
    },
    {
      label1: t('Consensus Algorithms'),
      label2: t('Proof of Work, Proof of Stake, Delegated Proof of Stake'),
    },
    {
      label1: t('Decentralized Storage'),
      label2: t('IPFS, Arweave'),
    },
    {
      label1: t('Cryptographic Algorithms'),
      label2: t('SHA-256, elliptic curve cryptography'),
    },
    {
      label1: t('Blockchain Frameworks'),
      label2: t('Hyperledger, Corda, Quorum'),
    },
    {
      label1: t('Web3 Development'),
      label2: t('Web3.js, Ethers.js'),
    },
    {
      label1: t('Token Standards'),
      label2: t('ERC-20, ERC-721, ERC-1155'),
    },
    {
      label1: t('Oracles'),
      label2: t('Chainlink'),
    },
    {
      label1: t('Wallet Development'),
      label2: t('MetaMask, Trust Wallet, hardware wallets'),
    },
    {
      label1: t('NFT'),
      label2: t('IPFS, Arweave'),
    },
  ];
  return (
    <>
      <div className="section-blockchain">
        <div className="section-blockchain__left">
          <p className="label-section">{t('Blockchain development')}</p>
        </div>
        <div className="section-blockchain__right">
          <p className="desc">
            {t(
              'We build secure and transparent blockchain solutions, including smart contracts, decentralized applications (DApps), and custom blockchain ecosystems. Our services empower businesses with trust, efficiency, and innovation in industries like finance, supply chain, and more.'
            )}
          </p>
          <div className="list-tags">
            {tags.map((tag) => (
              <div className="tag" key={tag}>
                {tag}
              </div>
            ))}
          </div>
          <div className="technology">
            <div className="label-technology">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
              >
                <circle cx="4" cy="4" r="4" fill="#7360F2" />
              </svg>
              <span>{t('Technology')}</span>
            </div>
            <div className="technology__right">
              {technology.map((item, index) => (
                <div className="item" key={index}>
                  <div className="label1">{item.label1}</div>
                  <div className="label2">{item.label2}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="section-ai-machine-learning">
        <p className="label-section">{t('AI & Machine Learning')}</p>
        <div className="section-ai-machine-learning__right">
          {t(
            'Harness the power of AI and ML with our advanced solutions. From predictive analytics and natural language processing to automation and personalized user experiences, we create intelligent systems that optimize operations and unlock new opportunities.'
          )}
        </div>
      </div>
    </>
  );
};

export default React.memo(SectionBlockChain);
